import { render, staticRenderFns } from "./Duty.vue?vue&type=template&id=b423a5f8&scoped=true"
import script from "./Duty.vue?vue&type=script&lang=js"
export * from "./Duty.vue?vue&type=script&lang=js"
import style0 from "./Duty.vue?vue&type=style&index=0&id=b423a5f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b423a5f8",
  null
  
)

export default component.exports